import React from "react";

import { Typography } from "@mui/material";

import { useIndicators } from "../../hooks/useIndicators";
import { useWidgetFetch } from "../../hooks/useWidgetFetch";
import { RendererProps } from "./types";

export const FigureWidget = (props: RendererProps) => {
  const { data, isLoading, error } = useWidgetFetch(props.config.id, props.config.dataSource, props.optionValues);
  const someIndicatorView = useIndicators(props, isLoading, error);
  if (someIndicatorView) {
    return someIndicatorView;
  }

  const { swapTitleAndFigure } = props.config.options || {};

  return swapTitleAndFigure ? (
    <div className="report__card_title">{data}</div>
  ) : (
    <div className="figure">
      <Typography variant="h3" gutterBottom>
        {!swapTitleAndFigure ? data : null}
      </Typography>
    </div>
  );
};
